import React, { useState } from "react";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import Container from "react-bootstrap/Container";
import logo from "../Assets/logo.png";
import Button from "react-bootstrap/Button";
import { Link } from "react-router-dom";
import { CgGitFork } from "react-icons/cg";
import { ImBlog } from "react-icons/im";
import {
  AiFillStar,
  AiOutlineHome,
  AiOutlineFundProjectionScreen,
  AiOutlineUser,
} from "react-icons/ai";

import { CgFileDocument } from "react-icons/cg";

function NavBar() {
  const [expand, updateExpanded] = useState(false);
  const [navColour, updateNavbar] = useState(false);

  const data = {
    logo: 1,
    home: 1,
    about: 1,
    projects: 1,
    resume: 0,
    blogs: 1,
    services: 1,
  };

  const [chk, setChk] = useState(data);

  function scrollHandler() {
    if (window.scrollY >= 20) {
      updateNavbar(true);
    } else {
      updateNavbar(false);
    }
  }

  window.addEventListener("scroll", scrollHandler);

  return (
    <Navbar
      expanded={expand}
      fixed="top"
      expand="md"
      className={navColour ? "sticky" : "navbar"}
    >
      <Container>
        {chk.logo == 1 ? (
          <Navbar.Brand href="/" className="d-flex">
            {/* <img src={logo} className="img-fluid logo" alt="brand" /> */}
            <strong className="purple" style={{fontSize:"30px"}}>Bp.</strong>
          </Navbar.Brand>
        ) : null}

        <Navbar.Toggle
          aria-controls="responsive-navbar-nav"
          onClick={() => {
            updateExpanded(expand ? false : "expanded");
          }}
        >
          <span></span>
          <span></span>
          <span></span>
        </Navbar.Toggle>

        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ms-auto" defaultActiveKey="#home">
            {chk.home == 1 ? (
              <Nav.Item>
                <Nav.Link
                  as={Link}
                  to="/"
                  onClick={() => updateExpanded(false)}
                >
                  <AiOutlineHome style={{ marginBottom: "2px" }} /> Home
                </Nav.Link>
              </Nav.Item>
            ) : null}

            {chk.about == 1 ? (
              <Nav.Item>
                <Nav.Link
                  as={Link}
                  to="/about"
                  onClick={() => updateExpanded(false)}
                >
                  <AiOutlineUser style={{ marginBottom: "2px" }} /> About
                </Nav.Link>
              </Nav.Item>
            ) : null}

            {chk.projects == 1 ? (
              <Nav.Item>
                <Nav.Link
                  as={Link}
                  to="/project"
                  onClick={() => updateExpanded(false)}
                >
                  <AiOutlineFundProjectionScreen
                    style={{ marginBottom: "2px" }}
                  />{" "}
                  Projects
                </Nav.Link>
              </Nav.Item>
            ) : null}

            {/* {chk.resume == 1 ? (
              <Nav.Item>
                <Nav.Link
                  as={Link}
                  to="/resume"
                  onClick={() => updateExpanded(false)}
                >
                  <CgFileDocument style={{ marginBottom: "2px" }} /> Resume
                </Nav.Link>
              </Nav.Item>
            ) : null} */}

            {/* {chk.blogs == 1 ? (
              <Nav.Item>
                <Nav.Link
                  href="https://soumyajitblogs.vercel.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <ImBlog style={{ marginBottom: "2px" }} /> Blogs
                </Nav.Link>
              </Nav.Item>
            ) : null} */}

            {/* {chk.services == 1 ? (
              <Nav.Item>
                <Nav.Link
                  href="https://soumyajitblogs.vercel.app/"
                  target="_blank"
                  rel="noreferrer"
                >
                  <ImBlog style={{ marginBottom: "2px" }} /> Services
                </Nav.Link>
              </Nav.Item>
            ) : null} */}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default NavBar;
